export default __webpack_public_path__ + "static/media/element-array.18cfa7c1.svg";